import React from 'react'; // eslint-disable-line
import { Interweave } from 'interweave';

/**
 * Class Spinner
 * @param {Object} props
 * @param {string} props.title
 * @param {string} props.text
 */
const Spinner = ({ title, text }) => (
  <div className="picsioSpinner partial previewViewSpinner" style={style}>
    <div className="innerPicsioSpinner">
      <div className="spinner">
        <div />
        <span />
      </div>
      <If condition={title}>
        <div className="titleSpinner show">
          <Interweave content={title} />
        </div>
      </If>

      <If condition={text}>
        <div className="textSpinner show">
          <Interweave content={text} />
        </div>
      </If>
    </div>
  </div>
);

const style = {
  zIndex: 4,
};

export default Spinner;
